import React, { Component } from 'react';

import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import BranchContractYearChart from './BranchContractYearChart';


class BranchContractYear extends Component {
	constructor(props) {
		super(props);
		this.state = {
            year : this.props.year,
            branch : null,
            branch_infos : null,
            tableData : null,
		}
	}


    componentWillReceiveProps = (nextProps) => {
        this.setState({
            branch : nextProps.branch,
            branch_infos : nextProps.branch_infos,
        }, () => {
        	this.setState({tableData: this.getData()});
        })
    }

    // 해당 년도에 계약된 원/어린이집이 없는 경우 리스트에서 제외
	getData = () => {
        var list = this.state.branch_infos
        var branch = this.state.branch
        var tableData = null
        if(list !== null && branch !== null) {
            var currentYear = new Date().getFullYear()
            tableData = []
            for(var year = 2017; year <= currentYear; year++) {
                tableData.push({
                    name: year,
                    전체: branch.contract[year].TOTAL,
                    신규: branch.contract[year].TOTAL_NEW,
                    재계약: branch.contract[year].TOTAL_RENEW,
                    순위: branch.contract[year].RANK,
                })
            }
        }
		return tableData;
	}

    render() {

        return (
            <div className="card border-top border-3 border-top-secondary" style={{ height: (this.props.height) + "px" }}>
                <div className="card-header d-flex" style={{padding:"0.3rem 1.25rem"}}>
                    <h5 className="card-header-title">
                        연도별 계약 정보
                    </h5>
                </div>
                <div className="card-body" style={{ padding: "0px", textAlign: "center", overflow: "auto" }}>
                    {(this.state.tableData === null) ? (
                        <span className="dashboard-spinner spinner-xxl" style={{ marginTop: "30px" }}></span>
                    ) : ((this.state.branch !== null && (this.state.tableData === null || this.state.tableData.length < 1)) ? (
                        <div className="text-center align-middle" style={{ width: "100%", height: "100%", padding: "70px 0" }}>No data</div>
                    ) : (
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-alpine" style={{ height: this.props.height + "px", padding: "0px" }}>
                                <BranchContractYearChart data={this.state.tableData} height={this.props.height - 15} onYearChange={this.props.onYearChange} />
                            </div>
                        )
                        )}
                </div>
            </div>
        )

    }

}


export default BranchContractYear;